'use es6';

import { bindAll } from 'underscore';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
import AllWidgetEditorsContainer from 'InpageEditorUI/containers/AllWidgetEditorsContainer';
import InpageRoot from 'InpageEditorUI/components/InpageRoot';
import InpageSidebarContainer from 'InpageEditorUI/components/InpageSidebarContainer';
import UnifiedOverlaysAndToolbarsContainer from 'InpageEditorUI/containers/UnifiedOverlaysAndToolbarsContainer';
import ModuleDomRenderContainer from 'InpageEditorUI/containers/ModuleDomRenderContainer';
import AppWideKeyboardShortcutsContainer from 'ContentEditorUI/containers/AppWideKeyboardShortcutsContainer';
import ResponsiveToolbarsMeasurementsContainer from 'InpageEditorUI/containers/ResponsiveToolbarsMeasurementsContainer';
import { LameNullErrorHandlerInIframe } from 'ContentEditorUI/components/lameErrorHandling';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction, layoutSectionHoverPositionsClearedAndFrozen as layoutSectionHoverPositionsClearedAndFrozenAction, layoutSectionHoverPositionsThawed as layoutSectionHoverPositionsThawedAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { setAddModuleSidebarLoaded } from 'ContentEditorUI/redux/actions/appActions';
import { INPAGE_SIDEBAR_IFRAME_WINDOW_NAME } from 'ContentEditorUI/lib/app/constants';
import { EVENT_ADD_WINDOW_TO_REACT_DND } from 'ContentEditorUI/lib/inpage/Constants';
import { getCurrentInpageMode, getHighlightedWidgetId, getScrollToModuleId, getUseScrollIfModuleOutOfBoundsAtAll, getNopeZoneSelector } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getSelectedModuleName, getIsAnythingSelected } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getHasTheme, getThemeObject, getOverriddenThemeSettings } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getComputedThemeSettings, getThemeGoogleFontsMap } from 'ContentEditorUI/redux/selectors/themeSelectorsAdvanced';
import { getHasUndoRedoAccess, getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { resetHighlightedWidgetId, updateInpageMode, updateIsDraggingModule } from 'ContentEditorUI/redux/actions/inpageActions';
import { undoModuleReducerChange, redoModuleReducerChange } from 'ContentEditorUI/redux/actions/undoRedoActions';
import { openPanel } from 'ContentEditorUI/redux/actions/panelActions';
import { clearOverriddenThemeSettings } from 'ContentEditorUI/redux/actions/themePageOverridesActions';
import { getRenderLanguage } from 'ContentEditorUI/redux/selectors/languageSelectors';
import { getActiveSidebarPanel, getSidebarSearchResultsMap, getXrayReadabilityType, getXrayReadabilityArr } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getIframeCaresAboutNextWindowClick } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getContentSaveRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import ThemeSettingsPreview from 'theme-previewer-lib/components/iframe/ThemeSettingsPreview';
import NodePositionContainer from 'InpageEditorUI/containers/NodePositionContainer';
import { hydrateHtmlStringIntoDomElement } from 'InpageEditorUI/lib/dom';
import BlurListenerContainer from 'InpageEditorUI/containers/layoutSection/BlurListenerContainer';
import LayoutSectionContainer from 'InpageEditorUI/containers/layoutSection/LayoutSectionContainer';
import PerformanceStatsOverlay from 'InpageEditorUI/containers/layoutSection/PerformanceStatsOverlay';
import { getScrollToNodePositionTop } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getHublet } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import StaticNopeZoneContainer from 'InpageEditorUI/containers/StaticNopeZoneContainer';
import BlogNopeZone from 'InpageEditorUI/components/BlogNopeZone';
import ModuleInsertionNopeZone from 'InpageEditorUI/components/ModuleInsertionNopeZone';
import { getFeatureFlag } from 'ContentEditorUI/redux/selectors/featureFlagsSelectors';
import { getCanUseCopilotCollaborationMinusContentAssistanceCheck } from 'ContentEditorUI/redux/selectors/featureSelectors';
import { FEATURE_FLAGS } from 'ContentEditorUI/redux/constants';
import { getIsBlogPost } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getCategoryToModulesMap } from 'ContentEditorUI/js/redux/selectors/categorizedModuleSchemaSelectors';
import { createSelector } from 'reselect';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import XrayReadabilityContainer from 'InpageEditorUI/containers/XrayReadabilityContainer';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import UITourBackButton from 'ui-shepherd-react/button/UITourBackButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FakeDropTarget from '../components/FakeDropTarget';
import { tellParentAboutSentryMessageInIframe } from 'ContentEditorUI/components/lameErrorHandling';
import InpageCopilotCollabSessionManager from './InpageCopilotCollabSessionManager';
import { getIsUngatedForUnifiedInpageInitialization } from 'ContentEditorUI/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const shouldUseBlogNopZone = createSelector(getIsBlogPost, isBlogPost => isBlogPost);
const AsyncInlineInstanceEditingContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'InlineInstanceEditingContainer' */'InpageEditorUI/containers/InlineInstanceEditingContainer'));
const mapStateToProps = state => {
  return {
    contentSaveRequestStatus: getContentSaveRequest(state),
    currentInpageMode: getCurrentInpageMode(state),
    highlightedWidgetId: getHighlightedWidgetId(state),
    hasUndoRedoAccess: getHasUndoRedoAccess(state),
    hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state),
    iframeCaresAboutNextWindowClick: getIframeCaresAboutNextWindowClick(state),
    renderLanguage: getRenderLanguage(state),
    selectedModuleName: getSelectedModuleName(state),
    isAnythingSelected: getIsAnythingSelected(state),
    scrollToModuleId: getScrollToModuleId(state),
    scrollToNodePositionTop: getScrollToNodePositionTop(state),
    activePanel: getActiveSidebarPanel(state),
    hasTheme: getHasTheme(state),
    theme: getThemeObject(state),
    computedThemeSettings: getComputedThemeSettings(state),
    googleFontsMap: getThemeGoogleFontsMap(state),
    overriddenThemeSettings: getOverriddenThemeSettings(state),
    useScrollIfModuleOutOfBoundsAtAll: getUseScrollIfModuleOutOfBoundsAtAll(state),
    hublet: getHublet(state),
    shouldUseNopeZonesForAllModules: getFeatureFlag(FEATURE_FLAGS.shouldUseNopeZonesForAllModules),
    hasBlogNopZone: shouldUseBlogNopZone(state),
    // TODO: Leaving this as false for now until we can coordinate both module level
    // and template level inline editable fields
    instanceEditingModeActive: false,
    canUseCopilotCollaboration: getCanUseCopilotCollaborationMinusContentAssistanceCheck(state),
    categoryToModulesSchemasMap: getCategoryToModulesMap(state),
    sidebarSearchResultsMap: getSidebarSearchResultsMap(state),
    xrayReadabilityType: getXrayReadabilityType(state),
    xrayReadabilityArr: getXrayReadabilityArr(state),
    nopeZoneSelector: getNopeZoneSelector(state),
    isUngatedForUnifiedInpageInitialization: getIsUngatedForUnifiedInpageInitialization(state),
    hasModuleInsertionEnabled: getFeatureFlag(FEATURE_FLAGS.moduleInsertion)
  };
};
const mapDispatchToProps = {
  clearOverriddenThemeSettings,
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction,
  layoutSectionHoverPositionsClearedAndFrozen: layoutSectionHoverPositionsClearedAndFrozenAction,
  layoutSectionHoverPositionsThawed: layoutSectionHoverPositionsThawedAction,
  openPanel,
  setAddModuleSidebarLoaded,
  resetHighlightedWidgetId,
  redoModuleReducerChange,
  undoModuleReducerChange,
  updateInpageMode,
  updateIsDraggingModule
};
class EditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      shouldRenderThemePreviewer: false
    };
    const {
      bus
    } = props;
    bindAll(this, 'handleRedoAction', 'handleUndoAction', 'handleSidebarTabChange', 'handleAddModuleSidebarLoaded', 'startDraggingFromFlexColumn', 'startDraggingFromInpageSidebar', 'endDraggingFromFlexColumn', 'endDraggingFromInpageSidebar', 'handleResetInpageMode', 'onError', 'refreshPreview', 'mountThemePreviewer', 'unmountThemePreviewer');
    this.setReduxBasedGlobals(props);
    bus.on('post:mountThemePreviewer', this.mountThemePreviewer);
    bus.on('post:umountThemePreviewer', this.unmountThemePreviewer);
  }
  componentDidMount() {
    const {
      bus
    } = this.props;
    this.handleDeprecatedInpageStyles();
    bus.trigger('reactTreeRendered');
    if (this.props.domReady && !this.props.isUngatedForUnifiedInpageInitialization) {
      this.initializeReactDndInSidebarIframe();
    }
    if (this.needsAddModuleSidebar()) {
      setTimeout(() => {
        const sidebarIframeWindow = window.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].window;
        if (!sidebarIframeWindow.__isReactDndBackendSetUp) {
          const errorMessage = 'ReactDnD backend not set up in sidebar iframe after two minutes when it should have been';
          console.error(errorMessage);
          tellParentAboutSentryMessageInIframe(errorMessage);
        }
      }, 1000 * 60 * 2);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      onScrollToWidget,
      scrollToModuleId,
      scrollToNodePositionTop,
      domReady
    } = prevProps;
    if (this.props.scrollToModuleId && scrollToModuleId !== this.props.scrollToModuleId) {
      onScrollToWidget(this.props.scrollToModuleId);
    }

    // Explicit null / undefined check so that "0" isn't coerced into false
    if (this.props.scrollToNodePositionTop !== null && scrollToNodePositionTop !== this.props.scrollToNodePositionTop) {
      window.scrollTo({
        top: this.props.scrollToNodePositionTop,
        behavior: 'smooth'
      });
    }
    if (this.props.domReady && !domReady && !this.props.isUngatedForUnifiedInpageInitialization) {
      this.initializeReactDndInSidebarIframe();
    }
  }
  dispatchInitReactDndInSidebar() {
    window.postMessage({
      type: EVENT_ADD_WINDOW_TO_REACT_DND,
      windowName: INPAGE_SIDEBAR_IFRAME_WINDOW_NAME
    }, '*');
  }
  initializeReactDndInSidebarIframe() {
    const sidebarIframeWindow = window.parent.frames[INPAGE_SIDEBAR_IFRAME_WINDOW_NAME].window;
    if (sidebarIframeWindow.document.readyState === 'complete') {
      this.dispatchInitReactDndInSidebar();
    } else {
      sidebarIframeWindow.document.addEventListener('load', this.dispatchInitReactDndInSidebar);
    }
  }
  mountThemePreviewer() {
    this.setState({
      shouldRenderThemePreviewer: true
    });
  }
  unmountThemePreviewer() {
    this.setState({
      shouldRenderThemePreviewer: false
    });
  }
  setReduxBasedGlobals(props) {
    window.HUBLET = props.hublet;
  }
  refreshPreview() {
    this.props.handlePreviewNeedsReload();
  }
  handleRedoAction() {
    this.props.redoModuleReducerChange();
  }
  handleUndoAction() {
    this.props.undoModuleReducerChange();
  }
  handleSidebarTabChange(tab) {
    this.props.openPanel(tab);
  }
  handleAddModuleSidebarLoaded() {
    this.props.setAddModuleSidebarLoaded();
  }
  startDraggingFromInpageSidebar({
    dragPayload
  }) {
    const {
      draggingStartedAndDeselectExisting
    } = this.props;
    const isSection = dragPayload.type === 'customSection' || dragPayload.type === 'customLayout';
    const dragId = isSection ? null : dragPayload.widgetCid;
    draggingStartedAndDeselectExisting(Object.assign({
      contentType: dragPayload.type,
      dragId,
      fromInpageSidebar: true
    }, isSection ? {
      isTopMostRow: true
    } : {}));
    this.setState({
      isDragging: true
    });
  }
  startDraggingFromFlexColumn({
    containerName,
    dragIndex
  }) {
    this.props.updateIsDraggingModule(true);
    this.setState({
      isDragging: true,
      widgetBeingDraggedIndex: dragIndex,
      widgetBeingDraggedParentContainer: containerName
    });
  }
  endDraggingFromInpageSidebar(dragItem, didDrop) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = this.props;
    draggingStoppedAndReselectIfNeeded(dragItem, didDrop);
    this.setState({
      isDragging: false,
      widgetBeingDraggedIndex: null,
      widgetBeingDraggedParentContainer: null
    });
  }
  endDraggingFromFlexColumn() {
    this.props.updateIsDraggingModule(false);
    this.setState({
      isDragging: false,
      widgetBeingDraggedIndex: null,
      widgetBeingDraggedParentContainer: null
    });
  }
  handleResetInpageMode() {
    this.props.updateInpageMode(InpageModes.DEFAULT);
  }
  needsAddModuleSidebar() {
    const {
      hasAnyContainerOrDndAreaToAddModules
    } = this.props;
    return hasAnyContainerOrDndAreaToAddModules;
  }
  onError(err) {
    console.error('Unable to reload stylesheet.', err);
  }

  // "Manually" inject styles that were in the inpage sass bundle into the document. Use gate to roll out _not_ inserting these so we can eventually remove them all together
  handleDeprecatedInpageStyles() {
    const stylesToDeprecate = [];

    // Note if we plan to have more styles to kill in the future (especially if they might not be simple ones and use SASS variables/mixins), then dynamically injecting a link tag to a specific CSS file might be far simpler.

    if (stylesToDeprecate.length) {
      const styleTag = hydrateHtmlStringIntoDomElement(`<style>${stylesToDeprecate.join('\n')}</style>`);
      document.head.appendChild(styleTag);
    }
  }
  getEmbedTourStepAttachTarget() {
    const {
      nopeZoneSelector
    } = this.props;
    // Try to get the element at the given selector, fall back to the first div
    // if we can't find a selector or an element at that selector
    if (nopeZoneSelector) {
      const element = document.querySelector(nopeZoneSelector);
      if (element) {
        return element;
      }
    }
    return document.querySelector('div');
  }
  render() {
    const {
      isDragging,
      widgetBeingDraggedIndex,
      widgetBeingDraggedParentContainer
    } = this.state;
    const {
      activePanel,
      bus,
      domReady,
      currentInpageMode,
      gates,
      hasUndoRedoAccess,
      highlightedWidgetId,
      iframeCaresAboutNextWindowClick,
      previewLoaded,
      renderLanguage,
      scrollToModuleId,
      selectedModuleName,
      hasBlogNopZone,
      shouldShowFakeWidgetEditors,
      sidebarIframeWindow,
      tellParentToHideModuleMenu,
      updateFlexColumnContents,
      updateNodePositions,
      moduleMissingErrors,
      hasTheme,
      theme,
      computedThemeSettings,
      contentSaveRequestStatus,
      overriddenThemeSettings,
      layoutSectionHoverPositionsClearedAndFrozen,
      layoutSectionHoverPositionsThawed,
      shouldUseNopeZonesForAllModules,
      instanceEditingModeActive,
      categoryToModulesSchemasMap,
      sidebarSearchResultsMap,
      xrayReadabilityType,
      xrayReadabilityArr,
      canUseCopilotCollaboration,
      hasModuleInsertionEnabled
    } = this.props;
    const {
      requestState
    } = contentSaveRequestStatus;
    const {
      shouldRenderThemePreviewer
    } = this.state;
    return /*#__PURE__*/_jsxs(InpageRoot, {
      currentInpageMode: currentInpageMode,
      onResetInpageMode: this.handleResetInpageMode,
      children: [hasTheme && shouldRenderThemePreviewer && /*#__PURE__*/_jsx(ThemeSettingsPreview, {
        clearUpdatedThemeSettings: this.props.clearOverriddenThemeSettings,
        hasHotReloadingAccess: true,
        onError: this.onError,
        pageLevelOverride: true,
        previewLoaded: previewLoaded,
        reloadIframePreview: this.refreshPreview,
        saveRequestStatus: requestState,
        theme: theme || {},
        themeSettings: computedThemeSettings || {},
        updatedThemeSettings: overriddenThemeSettings || {}
      }), this.needsAddModuleSidebar() ? /*#__PURE__*/_jsx(LameNullErrorHandlerInIframe, {
        children: /*#__PURE__*/_jsx(InpageSidebarContainer, {
          onRedoAction: this.handleRedoAction,
          onUndoAction: this.handleUndoAction,
          onAddModuleSidebarLoadedAction: this.handleAddModuleSidebarLoaded,
          onSidebarTabChange: this.handleSidebarTabChange,
          isActivePanel: activePanel === SIDEBAR_PANELS.addWidget,
          bus: bus,
          endDraggingFromInpageSidebar: this.endDraggingFromInpageSidebar,
          sidebarIframeWindow: sidebarIframeWindow,
          startDraggingFromInpageSidebar: this.startDraggingFromInpageSidebar,
          iframeCaresAboutNextWindowClick: iframeCaresAboutNextWindowClick,
          useOnDark: true,
          categoryToModulesSchemasMap: categoryToModulesSchemasMap,
          sidebarSearchResultsMap: sidebarSearchResultsMap
        }, "inpagesidebar")
      }) : null, domReady && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FakeDropTarget, {}), /*#__PURE__*/_jsx(LameNullErrorHandlerInIframe, {
          children: /*#__PURE__*/_jsx(ModuleDomRenderContainer, {
            bus: bus
          })
        }), !instanceEditingModeActive && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(AllWidgetEditorsContainer, {
            bus: bus,
            currentInpageMode: currentInpageMode,
            gates: gates,
            highlightedWidgetId: highlightedWidgetId,
            hasUndoRedoAccess: hasUndoRedoAccess,
            tellParentToHideModuleMenu: tellParentToHideModuleMenu,
            updateNodePositions: updateNodePositions,
            selectedModuleName: selectedModuleName,
            scrollToModuleId: scrollToModuleId,
            layoutSectionHoverPositionsClearedAndFrozen: layoutSectionHoverPositionsClearedAndFrozen,
            layoutSectionHoverPositionsThawed: layoutSectionHoverPositionsThawed,
            shouldShowFakeWidgetEditors: shouldShowFakeWidgetEditors,
            renderLanguage: renderLanguage,
            updateFlexColumnContents: updateFlexColumnContents,
            startDraggingFromFlexColumn: this.startDraggingFromFlexColumn,
            endDraggingFromFlexColumn: this.endDraggingFromFlexColumn,
            isDragging: isDragging,
            widgetBeingDraggedIndex: widgetBeingDraggedIndex,
            widgetBeingDraggedParentContainer: widgetBeingDraggedParentContainer,
            moduleMissingErrors: moduleMissingErrors
          }), /*#__PURE__*/_jsx(LameNullErrorHandlerInIframe, {
            children: /*#__PURE__*/_jsx(ResponsiveToolbarsMeasurementsContainer, {})
          }), /*#__PURE__*/_jsx(LameNullErrorHandlerInIframe, {
            children: !xrayReadabilityType && /*#__PURE__*/_jsxs(UnifiedOverlaysAndToolbarsContainer, {
              bus: bus,
              children: [/*#__PURE__*/_jsx(PerformanceStatsOverlay, {}), /*#__PURE__*/_jsx(LayoutSectionContainer, {
                bus: bus
              })]
            })
          }), /*#__PURE__*/_jsx(NodePositionContainer, {
            bus: bus
          })]
        }), instanceEditingModeActive && /*#__PURE__*/_jsx(AsyncInlineInstanceEditingContainer, {}), shouldUseNopeZonesForAllModules && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(UITourStep, {
            tourKey: "embed-editor-onboarding-tour",
            stepKey: "editEmbed",
            attachTo: this.getEmbedTourStepAttachTarget(),
            showCloseButton: true,
            showSteps: true,
            content: {
              header: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "inpage.embedTour.title"
              }),
              body: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "inpage.embedTour.body"
              }),
              footer: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsx(UITourBackButton, {}), /*#__PURE__*/_jsx(UITourNextButton, {
                  use: "primary"
                })]
              })
            }
          }), /*#__PURE__*/_jsx(StaticNopeZoneContainer, {})]
        }), hasBlogNopZone &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx("div", {
          className: "hs-private",
          children: /*#__PURE__*/_jsx(BlogNopeZone, {})
        }), hasModuleInsertionEnabled &&
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx("div", {
          className: "hs-private",
          children: /*#__PURE__*/_jsx(ModuleInsertionNopeZone, {})
        }), /*#__PURE__*/_jsxs(LameNullErrorHandlerInIframe, {
          children: [/*#__PURE__*/_jsx(BlurListenerContainer, {}), /*#__PURE__*/_jsx(AppWideKeyboardShortcutsContainer, {
            redoAction: this.handleRedoAction,
            undoAction: this.handleUndoAction
          })]
        }), /*#__PURE__*/_jsx(XrayReadabilityContainer, {
          xrayReadabilityType: xrayReadabilityType,
          xrayReadabilityArr: xrayReadabilityArr
        }), canUseCopilotCollaboration && /*#__PURE__*/_jsx(InpageCopilotCollabSessionManager, {})]
      })]
    });
  }
}
EditContainer.propTypes = {
  bus: PropTypes.object.isRequired,
  domReady: PropTypes.bool.isRequired,
  currentInpageMode: PropTypes.string.isRequired,
  gates: PropTypes.array.isRequired,
  highlightedWidgetId: PropTypes.string,
  hasAnyContainerOrDndAreaToAddModules: PropTypes.bool.isRequired,
  hasUndoRedoAccess: PropTypes.bool.isRequired,
  onScrollToWidget: PropTypes.func.isRequired,
  renderLanguage: PropTypes.string.isRequired,
  selectedModuleName: PropTypes.string,
  scrollToModuleId: PropTypes.string,
  scrollToNodePositionTop: PropTypes.number,
  shouldShowFakeWidgetEditors: PropTypes.func.isRequired,
  sidebarIframeWindow: PropTypes.object,
  tellParentToHideModuleMenu: PropTypes.func.isRequired,
  updateNodePositions: PropTypes.func.isRequired,
  updateFlexColumnContents: PropTypes.func.isRequired,
  setAddModuleSidebarLoaded: PropTypes.func.isRequired,
  draggingStartedAndDeselectExisting: PropTypes.func.isRequired,
  draggingStoppedAndReselectIfNeeded: PropTypes.func.isRequired,
  layoutSectionHoverPositionsClearedAndFrozen: PropTypes.func.isRequired,
  layoutSectionHoverPositionsThawed: PropTypes.func.isRequired,
  openPanel: PropTypes.func.isRequired,
  redoModuleReducerChange: PropTypes.func.isRequired,
  undoModuleReducerChange: PropTypes.func.isRequired,
  updateInpageMode: PropTypes.func.isRequired,
  updateIsDraggingModule: PropTypes.func.isRequired,
  activePanel: PropTypes.string.isRequired,
  iframeCaresAboutNextWindowClick: PropTypes.bool.isRequired,
  previewLoaded: PropTypes.bool.isRequired,
  hasTheme: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  computedThemeSettings: PropTypes.object.isRequired,
  contentSaveRequestStatus: PropTypes.object.isRequired,
  clearOverriddenThemeSettings: PropTypes.func.isRequired,
  overriddenThemeSettings: PropTypes.array.isRequired,
  handlePreviewNeedsReload: PropTypes.func.isRequired,
  hasBlogNopZone: PropTypes.bool.isRequired,
  shouldUseNopeZonesForAllModules: PropTypes.bool.isRequired,
  /* eslint-disable react/no-unused-prop-types */
  hublet: PropTypes.string.isRequired,
  // Specific state that some widget editors need (eventually to be retrieved via redux instead
  // of passing to _all_ widget editors)
  moduleMissingErrors: PropTypes.array.isRequired,
  isUngatedForCollaborateWithCopilot: PropTypes.bool,
  instanceEditingModeActive: PropTypes.bool,
  categoryToModulesSchemasMap: PropTypes.object.isRequired,
  sidebarSearchResultsMap: PropTypes.object,
  xrayReadabilityType: PropTypes.string,
  xrayReadabilityArr: PropTypes.array,
  nopeZoneSelector: PropTypes.string,
  canUseCopilotCollaboration: PropTypes.bool,
  isUngatedForUnifiedInpageInitialization: PropTypes.bool.isRequired,
  hasModuleInsertionEnabled: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToProps)(EditContainer);